export const routes = {
  lineUps: 'lineups',
  officials: 'officials',
  squadDetails: 'squaddetails',
  standings: 'standings',
  statistics: 'statistics',
  printMatchPressKits: 'printmatchpresskits',
  print: 'print',
} as const;
